"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OrderRepository_1 = __importDefault(require("../repositories/OrderRepository"));
var OrderService = /** @class */ (function () {
    function OrderService() {
    }
    OrderService.getFirstAvailableFulfilmentTime = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getFirstAvailableFulfilmentTime(payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.calculateTime = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.calculateTime(order)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.calculateOrderDelivery = function (details) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.calculateOrderDelivery(details)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.confirmTime = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.confirmTime(order)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.create = function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.create(order)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.createMenuOrder = function (menuOrder) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, OrderRepository_1.default.createMenuOrder(menuOrder)];
            });
        });
    };
    OrderService.getDetails = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getDetails(orderId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_6 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_6)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.delete = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.delete(orderId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_7 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_7)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.getStatus = function (orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getStatus(orderId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_8 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_8)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.getPendingOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_9;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getPendingOrders()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_9 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_9)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.getPastOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_10;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getPastOrders()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_10 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_10)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.getStorefrontOrders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_11;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.getStorefrontOrders()];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_11 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_11)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.checkCoupon = function (code, total) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_12;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, OrderRepository_1.default.checkCoupon(code, total)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, Promise.resolve(response)];
                    case 2:
                        e_12 = _a.sent();
                        return [2 /*return*/, Promise.reject(e_12)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderService.orderIsReceived = function (status) {
        return status === OrderRepository_1.default.getReceivedStatus();
    };
    OrderService.orderIsReady = function (status) {
        return status === OrderRepository_1.default.getReadyStatus();
    };
    OrderService.orderIsPickedUp = function (status) {
        return status === OrderRepository_1.default.getPickedUpStatus();
    };
    return OrderService;
}());
exports.default = OrderService;
